export const USER_ROLE_ADMINISTRATOR = 'administrator';
export const USER_ROLE_LEADER = 'leader';
export const USER_ROLE_MODERATOR = 'moderator';
export const USER_ROLE_PARTNER = 'partner';
export const USER_ROLE_PERFORMER = 'performer';
export const USER_ROLE_ROOT = 'root';